














































    import { LocaleMixin } from '@/locales/locale-mixin';
    import { Component, Mixins, Prop, PropSync, Watch } from 'vue-property-decorator';
    import { TaskReminderUnits } from '@/tasks/models/task-models';
    import pluralize from 'pluralize';
    import { BasicValidationMixin } from '@/validation/basic-validation-mixin';
    import { getModule } from 'vuex-module-decorators';
    import { FeaturesStore } from '@/features/features-store';

    const featureState = getModule(FeaturesStore);
@Component
    export default class SendReminderInputs extends Mixins(LocaleMixin, BasicValidationMixin) {
    @PropSync('amountInput', { type: String }) amountSynced!: string;
    @PropSync('unitInput', { type: String }) unitSynced!: string;

    @Prop({ default: false }) readonly sendReminder!: boolean;
    @Prop({ default: false }) readonly disabled!: boolean;

    private reminderAmountRules = [
        (v: string|number) => (v !== null && v !== undefined && String(v).trim() !== '' ? true : 'Please enter a value'),
        (v: string|number) => {
            const num = Number(v);
            return (Number.isInteger(num) && num >= 1 && num <= 999) ? true : 'Please enter a value between 1 and 999';
        }
    ];

    get isValidAmount(): boolean {
        if (this.isNewTaskModal) {
            if (!this.amountSynced) return false;
            const num = Number(this.amountSynced);
            return Number.isInteger(num) && num >= 1 && num <= 999;
        }
        return true;
    }

    private capitalizeFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    get isNewTaskModal() {
        return featureState.isNewTaskModal;
    }

    get isLineLeaderEnroll(): boolean {
            return featureState.isLineLeaderEnroll;
    }

    private reminderUnitOptions = [
        {
            value: TaskReminderUnits.MINUTES,
            label: this.capitalizeFirstLetter(pluralize(TaskReminderUnits.MINUTES))
        },
        {
            value: TaskReminderUnits.HOURS,
            label: this.capitalizeFirstLetter(pluralize(TaskReminderUnits.HOURS))
        },
        {
            value: TaskReminderUnits.DAYS,
            label: this.capitalizeFirstLetter(pluralize(TaskReminderUnits.DAYS))
        }
        ];

    @Watch('amountSynced')
    updateAmountInput() {
        this.$emit('input-amount');
        if (this.isNewTaskModal) {
            this.$emit('validation-change', this.isValidAmount);
        }
    }

    @Watch('unitSynced')
    updateUnitInput() {
        this.$emit('input-unit');
    }

    @Watch('isValidAmount', { immediate: true })
    onValidationChange() {
        if (this.isNewTaskModal) {
            this.$emit('validation-change', this.isValidAmount);
        }
    }

    async mounted() {
        await featureState.init();
    }
    }

